import React from 'react'

export const Portfolio = () => {
  return (
    <div>
      <div className='container portfolio'>
        <h2>Portfolio</h2>
      </div>
      <div className="container">
     
       
    <div class="gallery2">
        <div class="gallery2-item">
            <img src="g1.jpg" alt="Image 1"/>
            <div class="overlay">Project 1</div>
        </div>
        <div class="gallery2-item">
            <img src="g2.jpg" alt="Image 2"/>
            <div class="overlay">Project 2</div>
        </div>
        <div class="gallery2-item">
            <img src="g3.jpg" alt="Image 3"/>
            <div class="overlay">Project 3</div>
        </div>
        <div class="gallery2-item">
            <img src="g4.jpg" alt="Image 4"/>
            <div class="overlay">Project 4</div>
        </div>
        <div class="gallery2-item">
            <img src="g5.jpg" alt="Image 4"/>
            <div class="overlay">Project 5</div>
        </div>
        <div class="gallery2-item">
            <img src="g6.jpg" alt="Image 4"/>
            <div class="overlay">Project 6</div>
        </div>
        <div class="gallery2-item">
            <img src="g7.jpg" alt="Image 4"/>
            <div class="overlay">Project 7</div>
        </div>
        <div class="gallery2-item">
            <img src="g8.jpg" alt="Image 4"/>
            <div class="overlay">Project 8</div>
        </div>
        <div class="gallery2-item">
            <img src="g9.jpg" alt="Image 4"/>
            <div class="overlay">Project 9</div>
        </div>
        <div class="gallery2-item">
            <img src="g10.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g11.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g12.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g13.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g14.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g15.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
        <div class="gallery2-item">
            <img src="Images/g16.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
    </div>
  
      </div>
    </div>
  )
}
